import Option from './Option';
import OptionGroup from './OptionGroup';
import MultiOption from './MultiOption';
import MultiOptionGroup from './MultiOptionGroup';

Option.Group = OptionGroup;
MultiOption.Group = MultiOptionGroup;

export { MultiOption };
export default Option;
